import {AppLanguage} from '@/logged/common/composables';
import {I18nService} from '@malt/vue3-i18n';
import {computed} from 'vue';
import type {TourDefinition} from '../onboarding-existing-user.types';

export function useTourDefinition() {
    const allTourDefinition = computed((): TourDefinition[] => [
        {
            navTabId: 'FindFreelancer',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/existing-client/FR/find-freelancer.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/existing-client/EN/find-freelancer.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/existing-client/ES/find-freelancer.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/existing-client/DE/find-freelancer.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/existing-client/NL/find-freelancer.png',
            },
            title: I18nService.msg('navbar.tour.find.freelancer.title'),
            body: I18nService.msg('navbar.tour.find.freelancer.body'),
        },
        {
            navTabId: 'FollowUpApplications',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/existing-client/FR/process-applications.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/existing-client/EN/process-applications.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/existing-client/ES/process-applications.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/existing-client/DE/process-applications.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/existing-client/NL/process-applications.png',
            },
            title: I18nService.msg('navbar.tour.followup.application.title'),
            body: I18nService.msg('navbar.tour.followup.application.body'),
        },
        {
            navTabId: 'ManageJobs',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/existing-client/FR/manage-projects.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/existing-client/EN/manage-projects.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/existing-client/ES/manage-projects.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/existing-client/DE/manage-projects.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/existing-client/NL/manage-projects.png',
            },
            title: I18nService.msg('navbar.tour.manage.projects.title'),
            body: I18nService.msg('navbar.tour.manage.projects.body'),
        },
        {
            navTabId: 'Monitoring',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/existing-client/FR/reporting.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/existing-client/EN/reporting.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/existing-client/ES/reporting.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/existing-client/DE/reporting.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/existing-client/NL/reporting.png',
            },
            title: I18nService.msg('navbar.tour.accounting.title'),
            body: I18nService.msg('navbar.tour.accounting.body'),
        },
        {
            navTabId: 'AccountSettings',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/existing-client/FR/collaborateurs.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/existing-client/EN/collaborateurs.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/existing-client/ES/collaborateurs.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/existing-client/DE/collaborateurs.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/existing-client/NL/collaborateurs.png',
            },
            title: I18nService.msg('navbar.tour.account-settings.title'),
            body: I18nService.msg('navbar.tour.account-settings.body'),
        },
        {
            navTabId: 'Messages',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/existing-client/FR/messenger.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/existing-client/EN/messenger.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/existing-client/ES/messenger.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/existing-client/DE/messenger.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/existing-client/NL/messenger.png',
            },
            title: I18nService.msg('navbar.tour.messages.title'),
            body: I18nService.msg('navbar.tour.messages.body'),
        },
    ]);

    return allTourDefinition;
}
